import DefaultTemplate from "../layout/content-templates/default/DefaultTemplate.tsx";
import styles from "./Home.module.scss";
import HomeFeatures from "./widgets/HomeFeatures.tsx";
import RecentBooks from "./widgets/RecentBooks.tsx";
import ReaderTips from "./widgets/ReaderTips.tsx";
import DashboardBanners from "./widgets/DashboardBanners.tsx";
import FacultyWelcomeModal from "../common/faculty-welcome-modal/FacultyWelcomeModal.tsx";
import PromoRow from "./widgets/PromoRow.tsx";
import OffScreen from "../../../common/core-ui/OffScreen.tsx";
import { useIntl } from "react-intl";
import PaddedDotLoader from "../search/common/PaddedDotLoader.tsx";
import { Suspense, useEffect } from "react";
import { useRecentBooksLoaderData } from "./dashboardLoader.ts";
import DefaultError from "../../../common/core-ui/DefaultError.tsx";
import { Await } from "react-router-dom";
import PageTitle from "../common/page-title/PageTitle.tsx";
import FreeBooks from "./widgets/FreeBooks.tsx";
import BrandedCollections from "./widgets/BrandedCollections.tsx";
import { useHomeContextUser } from "../homeContext.ts";
import { logEvent } from "../../../common/api/monitoring/index.ts";

export default function Home() {
  const loaderData = useRecentBooksLoaderData();
  const intl = useIntl();
  const title = intl.formatMessage({ defaultMessage: "Home Dashboard" });
  const user = useHomeContextUser();

  useEffect(() => {
    const hasLogged = sessionStorage.getItem(
      "instructor_dashboard_landing_logged"
    );

    if (user.instructor.hasRole && !hasLogged) {
      logEvent("instructor_dashboard_landing", {
        verifiedInstructor: user.instructor.verified,
      });
      sessionStorage.setItem("instructor_dashboard_landing_logged", "true");
    }
  }, [user.instructor.hasRole, user.instructor.verified]);

  return (
    <>
      <FacultyWelcomeModal />
      <DefaultTemplate title={title}>
        <div className={styles.container}>
          {/* Prefer putting show/hide decisions inside individual widgets */}
          <DashboardBanners />
          <OffScreen>
            <PageTitle title={title} />
          </OffScreen>
          <Suspense fallback={<PaddedDotLoader />}>
            <Await resolve={loaderData} errorElement={<DefaultError />}>
              {(response: Awaited<typeof loaderData>) => {
                if (response.ok && response.data) {
                  const total = response.meta?.page?.totals.items ?? 0;
                  return (
                    <>
                      <RecentBooks books={response.data} total={total} />
                      <BrandedCollections />
                      <HomeFeatures bookCount={total} />
                    </>
                  );
                }
              }}
            </Await>
          </Suspense>
          <PromoRow />
          <FreeBooks />
          <ReaderTips />
        </div>
      </DefaultTemplate>
    </>
  );
}
